import { api } from "./client";
import { unwrapApiList } from "./unwrap";

/** org_verticals.vertical_code — matches backend. */
export const VerticalCode = {
  TRADING: 0,
  MANUFACTURING: 1,
  SERVICES: 2,
} as const;

export type VerticalCodeValue = (typeof VerticalCode)[keyof typeof VerticalCode];

export interface OrgSettings {
  org_id: string;
  org_name: string;
  base_currency: string;
  vertical_code: VerticalCodeValue;
  tax_registration_number: string | null;
}

export interface OrgBranch {
  branchId: string;
  branchCode: string;
  nameI18nKey: string;
  status: number;
}

export interface OrgMember {
  userId: string;
  displayName: string;
  email: string;
  status: number;
}

export async function fetchOrgSettings(): Promise<OrgSettings> {
  const res = await api.get<{ ok: true; org: OrgSettings }>("/v1/settings/org");
  if (!res.ok || !("org" in res)) {
    throw new Error("Failed to load organization settings");
  }
  return res.org;
}

export async function fetchBranches(): Promise<OrgBranch[]> {
  const res = await api.get<{ ok: true; data: OrgBranch[] }>("/v1/org/branches");
  return unwrapApiList(res);
}

export async function fetchOrgMembers(): Promise<OrgMember[]> {
  const res = await api.get<{ ok: true; data: OrgMember[] }>("/v1/org/members");
  return unwrapApiList(res);
}
